module.exports = __webpack_public_path__ + "static/media/ready_for_duty.840863fb.mp3";